<template>
    <div>
        <h1>Inscrição na ONHB: passo '{{currentSubsStep}}'</h1>
        <div v-if="amILoading">
            <hr/>
            <strong>CARREGANDO ALGUMA COISA...</strong>
            <hr/>
        </div>

        <step-new v-if="currentSubsStep == 'new'" />

        <step-institution v-if="currentSubsStep == 'institution'" />

        <step-teachers v-if="currentSubsStep == 'teachers'"/>

        <step-user-id v-if="currentSubsStep == 'user'" />

    </div>
</template>

<script>
    import StepNew from "../components/OnhbSubscripion/StepNew";
    import {mapGetters} from "vuex";
    import StepInstitution from "../components/OnhbSubscripion/StepInstitution";
    import StepTeachers from "../components/OnhbSubscripion/StepTeachers";
    import StepUserId from "../components/OnhbSubscripion/StepUserId";
    export default {
        name: "OnhbSubscription",
        components: {StepUserId, StepTeachers, StepInstitution, StepNew},
        computed: {
            ...mapGetters([
                'currentSubsStep',
                'amILoading'
            ])
        }
    }
</script>

<style scoped>

</style>